// Builder content loader. Composes the discrete JSON files into one validated bundle.
// Tests stub the loader by constructing BuilderContent directly.

import { BuilderContentSchema } from './schemas.js';
import type {
  AssetDef,
  BuilderContent,
  BusinessDef,
  EventCardDef,
  LiabilityDef,
  QuestDef,
  SkillDef,
  TuningDef,
} from './types.js';

export type BuilderRawSource = {
  tuning: unknown;
  businesses: unknown;
  assets: unknown;
  liabilities: unknown;
  events: unknown;
  skills: unknown;
  quests: unknown;
};

export function composeBuilderContent(src: BuilderRawSource): BuilderContent {
  const candidate = {
    mode: 'builder' as const,
    enabled: true as const,
    tuning: src.tuning as TuningDef,
    businesses: src.businesses as BusinessDef[],
    assets: src.assets as AssetDef[],
    liabilities: src.liabilities as LiabilityDef[],
    events: src.events as EventCardDef[],
    skills: src.skills as SkillDef[],
    quests: src.quests as QuestDef[],
  };
  return BuilderContentSchema.parse(candidate);
}

/** Convenience accessors so callers don't write .find() everywhere. */
export function findBusiness(content: BuilderContent, id: string): BusinessDef | undefined {
  return content.businesses.find((b) => b.id === id);
}

export function findAsset(content: BuilderContent, id: string): AssetDef | undefined {
  return content.assets.find((a) => a.id === id);
}

export function findLiability(content: BuilderContent, id: string): LiabilityDef | undefined {
  return content.liabilities.find((l) => l.id === id);
}
